import videojs from 'video.js';
import getIconDelete from '../templates/delete.svg.html';

const dom = videojs.dom || videojs;

const Component = videojs.getComponent('Component');

class AttachedFiles extends Component {
	constructor(player, options) {
		super(player, options);
		this._options = options;
		this._files = [];
	}

	add(files) {
		if (!files.length) return;

		const numberAvailablePlaces = this._options.maxFilesLength - this._files.length;

		// Выводим ошибку, но прикрепляем картинки.
		if (files.length > numberAvailablePlaces) this._options.onFilesLengthError();

		const filesToAttach = Array.from(files).slice(0, numberAvailablePlaces);

		filesToAttach.forEach((file) => {
			let fileContainer;

			this._files.push(file);

			let deleteButton = dom.createEl('button', {
				className: 'vjs-chat-form-body__delete-attached-file',
				innerHTML: getIconDelete({ width: 7, height: 7 })
			});
			deleteButton.addEventListener('click', () => {
				this.remove(file, fileContainer);
			});

			fileContainer = dom.createEl('div', {
				className: 'vjs-chat-form-body__attached-file-container'
			}, {
				title: file.name,
				style: `background-image: url('${URL.createObjectURL(file)}')`
			}, [
				deleteButton
			]);

			dom.appendContent(this.contentEl(), fileContainer);
		});

		const streamShoppingSlider = this.player().getChild('StreamShoppingSlider');
		if (streamShoppingSlider) {
			streamShoppingSlider.updateBottomPosition();
		}

		this._options.onUpdate(this.getFiles());
	}

	remove(fileToDelete, fileContainer) {
		if (!fileContainer) return;
		this.contentEl().removeChild(fileContainer);
		this._files = this._files.filter((file) => file !== fileToDelete);
		this._options.onUpdate(this.getFiles());

		const streamShoppingSlider = this.player().getChild('StreamShoppingSlider');
		if (streamShoppingSlider) {
			streamShoppingSlider.updateBottomPosition();
		}
	}

	getFiles() {
		return this._files.slice();
	}

	clear() {
		const containerNodeList = this.$$('.vjs-chat-form-body__attached-file-container');
		const containerList = Array.from(containerNodeList);
		containerList.forEach((container) => container.parentNode.removeChild(container));
		this._files = [];
		this._options.onUpdate(this.getFiles());
	}
}

export { AttachedFiles };
